<template>
    <div>
        <slot :signal="signal"></slot>
    </div>
</template>
<script setup>
import {inject} from 'vue';

const props = defineProps(['marker', 'target']);
defineEmits(['clicked']);

const signalWrapper = inject('signalWrapper', (_a, _b) => {})

function signal(e) {
    signalWrapper(props?.marker, props?.target)
}

</script>
